



























import Vue, {VueConstructor} from 'vue'
import elementResizeDetectorMaker, {Erd} from 'element-resize-detector'

export default (Vue as VueConstructor<Vue & {
  $refs: {
    verticalScroller: HTMLElement,
    horizontalScroller: HTMLElement,
    content: HTMLElement,
    wrapper: HTMLElement
  }
}>).extend({
  name: 'BzScrollbar',
  data () {
    return {
      content: {
        marginBottom: '0',
        width: '100%'
      },
      scroller: {
        top: '0px',
        height: '0px'
      },
      horizontalScroller: {
        left: '0px',
        width: '0px'
      },
      horizontalScrollbar: {
        width: '100%',
        bottom: '0px'
      },
      verticalScrollSize: 0,
      verticalOversize: false,
      horizontalScrollFloaterRichBlockEnd: false,
      horizontalScrollSize: 0,
      horizontalOversize: false,
      resizeDetectorWrapper: null as Erd | null,
      resizeDetectorContent: null as Erd | null,
      resizeObserver: null as ResizeObserver | null,
      // Used to detect the iframe being hidden (content collapses to 0px)
      // and shown again, so Safari's scroll layer can be rebuilt.
      lastClientHeight: 0,
      hasMeasured: false,
      scrolled: 0 as any,
      down: false as string | boolean,
      downOffset: false as string | boolean,
      downVertical: false,
      moved: false,
      wrapperSize: {
        h: 0,
        w: 0
      },
      contentSize: {
        h: 0,
        w: 0
      }
    }
  },
  mounted () {
    this.hideScroll()
    this.setScrollerSize()
    this.bindResize()
    this.calcFloatedScrollbar()
    this.setDefaultScrollPosition()
    this.$refs.content.addEventListener('scroll', this.onScroll)
    window.addEventListener('mousemove', this.onMove)
    window.addEventListener('mouseup', this.onUp)
    window.addEventListener('scroll', this.onGlobalScroll, true)
  },
  beforeDestroy () {
    this.offResize()
    this.$refs.content.removeEventListener('scroll', this.onScroll)
    window.removeEventListener('mouseup', this.onUp)
    window.removeEventListener('mousemove', this.onMove)
    window.removeEventListener('scroll', this.onGlobalScroll, true)
  },
  props: {
    contain: {
      type: Boolean,
      default: false
    },
    slideScroll: {
      type: Number,
      default: 0
    },
    floatedHorizontalScroll: {
      type: Boolean,
      default: false
    },
    defaultScrollPosition: {
      type: String,
      default: 'top'
    },
    // Distance (px) from the top edge at which `onScrollUp` is emitted.
    // 0 keeps the legacy "exactly at the top" behavior. A positive value
    // lets consumers (e.g. messenger history) start loading *before* the
    // kinetic scroll slams into the boundary.
    topThreshold: {
      type: Number,
      default: 0
    }
  },
  methods: {
    onGlobalScroll (event: UIEvent) {
      const target = event.target as HTMLElement
      if (this.floatedHorizontalScroll && target.contains(this.$el)) {
        this.calcFloatedScrollbar()
      }
    },
    calcFloatedScrollbar () {
      if (this.floatedHorizontalScroll && this.$refs.horizontalScroller) {
        this.horizontalScrollFloaterRichBlockEnd = false
        const coords = this.$el.getBoundingClientRect()
        const scrollCoords = this.$refs.horizontalScroller.getBoundingClientRect()
        if (window.innerHeight > coords.top + coords.height) {
          this.horizontalScrollbar.bottom = window.innerHeight - (coords.top + coords.height) + 'px'
          this.horizontalScrollFloaterRichBlockEnd = true
        } else if (window.innerHeight - coords.top - scrollCoords.height < 0) {
          this.horizontalScrollbar.bottom = window.innerHeight - coords.top - scrollCoords.height + 'px'
        } else if (this.horizontalScrollbar.bottom !== '0px') {
          this.horizontalScrollbar.bottom = '0px'
        }
      } else if (this.horizontalScrollbar.bottom !== '0px') {
        this.horizontalScrollbar.bottom = '0px'
      }

    },
    slideTo (direction: string) {
      const left = direction === 'left'
      const closestSlide = this.closestSlide()
      const paddingLeft = parseInt(window.getComputedStyle(this.$refs.wrapper, null).getPropertyValue('padding-left'), 10)
      const newSlide = (left ? closestSlide!.previousSibling : closestSlide!.nextSibling) as HTMLElement | null
      if (newSlide) {
        this.$refs.content.scrollTo({
          left: newSlide!.offsetLeft - paddingLeft,
          behavior: 'smooth'
        })
      }
    },
    setDefaultScrollPosition () {
      if (this.defaultScrollPosition === 'bottom') {
        const content = this.$refs.content
        setTimeout(() => {
          if (content.scrollHeight) {
            content.scrollTop = content.scrollHeight - content.clientHeight
          }
        }, 100)
      }
    },
    onClick (event: MouseEvent) {
      const content = this.$refs.content
      const target = event.target as HTMLElement
      if (this.downVertical) {
        const scrollerSize = content.clientHeight / content.scrollHeight * content.clientHeight
        if (target.classList.contains('bz-scrollbar__scroll--scroller')) {
          this.setScrollByTopCoord(target.offsetTop + event.offsetY - scrollerSize / 2)
        } else {
          this.setScrollByTopCoord(event.offsetY - scrollerSize / 2)
        }
      } else {
        const scrollerSize = content.clientWidth / content.scrollWidth * content.clientWidth
        if (target.classList.contains('bz-scrollbar__horizontalScroll--scroller')) {
          this.setScrollByLeftCoord(target.offsetLeft + event.offsetX - scrollerSize / 2)
        } else {
          this.setScrollByLeftCoord(event.offsetX - scrollerSize / 2)
        }
      }
    },
    setScrollByTopCoord (top: number) {
      const content = this.$refs.content
      const scrollerSize = content.clientHeight / content.scrollHeight * content.clientHeight
      const clickPosition = top / (content.clientHeight - scrollerSize)
      const scrollSize = content.scrollHeight - content.clientHeight

      if (clickPosition < 0 && content.scrollTop > 0) {
        content.scrollTop = 0
      } else if (clickPosition > 1 && content.scrollTop < scrollSize) {
        content.scrollTop = scrollSize
      } else {
        content.scrollTop = scrollSize * clickPosition
      }
    },
    setScrollTop (top: number) {
      // Intentionally synchronous: deferring to rAF lets the browser
      // paint a frame at the wrong position first (visible jump).
      this.$refs.content.scrollTop = top
    },
    slideScrollToBottom () {
      const content = this.$refs.content
      // this.setScrollTop(content.scrollHeight - content.clientHeight)
    },
    setScrollByLeftCoord (left: number) {
      const content = this.$refs.content
      const scrollerSize = content.clientWidth / content.scrollWidth * content.clientWidth
      const clickPosition = left / (content.clientWidth - scrollerSize)
      const scrollSize = content.scrollWidth - content.clientWidth

      if (clickPosition < 0 && content.scrollLeft > 0) {
        content.scrollLeft = 0
      } else if (clickPosition > 1 && content.scrollLeft < scrollSize) {
        content.scrollLeft = scrollSize
      } else {
        content.scrollLeft = scrollSize * clickPosition
      }
    },
    onDown (event: MouseEvent, vertical = false) {
      this.$store.commit('appInterface/disableSelect', true)
      this.moved = false
      this.down = event.screenX + ':' + event.screenY
      this.downVertical = vertical
      const target = event.target as HTMLElement
      const content = this.$refs.content
      if (target.classList.contains('bz-scrollbar__scroll--scroller') || target.classList.contains('bz-scrollbar__horizontalScroll--scroller')) {
        this.downOffset = event.offsetX + ':' + event.offsetY
      } else {
        if (this.downVertical) {
          const scrollerSize = content.clientHeight / content.scrollHeight * content.clientHeight
          this.downOffset = '0:' + scrollerSize / 2
        } else {
          const scrollerSize = content.clientWidth / content.scrollWidth * content.clientWidth
          this.downOffset = scrollerSize / 2 + ':0'
        }
      }
    },
    onMove (event: MouseEvent) {
      if (this.down && this.down !== event.screenX + ':' + event.screenY) {
        this.moved = true
        if (this.downVertical) {
          const downY = parseInt((this.downOffset as string).split(':')[1], 10)
          const offset = event.clientY - this.$refs.content.getBoundingClientRect().top - downY
          this.setScrollByTopCoord(offset)
        } else {
          const downX = parseInt((this.downOffset as string).split(':')[0], 10)
          const offset = event.clientX - this.$refs.content.getBoundingClientRect().left - downX
          this.setScrollByLeftCoord(offset)
        }
      }
    },
    onUp (event: MouseEvent) {
      if (this.down) {
        this.down = false
        this.$store.commit('appInterface/disableSelect', false)
        if (!this.moved) {
          this.onClick(event)
        }
      }
    },
    bindResize () {
      // ResizeObserver is preferred over element-resize-detector because it
      // reliably fires when an element transitions from size 0 (parent is
      // display:none) to its actual size (parent becomes visible again).
      // element-resize-detector with strategy:'scroll' often misses this
      // transition, which is exactly the collapse→expand repro path.
      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(() => {
          this.scrolledEffect()
          this.hideScroll()
          this.setScrollerSize()
          this.setScrollPosition()
          this.calcFloatedScrollbar()
          this.handleVisibilityRecover()
        })
        this.resizeObserver.observe(this.$refs.wrapper)
        this.resizeObserver.observe(this.$refs.content)
      } else {
        // Fallback for browsers that do not support ResizeObserver.
        this.resizeDetectorWrapper = elementResizeDetectorMaker({ strategy: 'scroll' })
        this.resizeDetectorWrapper!.listenTo(this.$refs.wrapper, this.onWrapperResize)
        this.resizeDetectorContent = elementResizeDetectorMaker({ strategy: 'scroll' })
        this.resizeDetectorContent!.listenTo(this.$refs.content, this.onContentResize)
      }

      this.$nextTick(() => {
        const wrapper = this.$refs.wrapper
        this.wrapperSize = {
          h: wrapper.clientHeight,
          w: wrapper.clientWidth,
        }
        const content = this.$refs.content
        this.contentSize = {
          h: content.clientHeight,
          w: content.clientWidth,
        }
      })
    },
    offResize () {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect()
        this.resizeObserver = null
        return
      }
      if (this.resizeDetectorWrapper) {
        this.resizeDetectorWrapper!.uninstall(this.$refs.wrapper)
        this.resizeDetectorWrapper = null
      }
      if (this.resizeDetectorContent) {
        this.resizeDetectorContent!.uninstall(this.$refs.content)
        this.resizeDetectorContent = null
      }
    },
    hideScroll () {
      const content = this.$refs.content

      this.verticalScrollSize = content.offsetWidth - content.clientWidth
      this.horizontalScrollSize = content.offsetHeight - content.clientHeight
      if (this.verticalScrollSize > 0) {
        this.content.width = `calc(100% + ${this.verticalScrollSize}px)`
      } else {
        this.content.width = `100%`
      }
      if (this.horizontalScrollSize > 0) {
        this.content.marginBottom = `-${this.horizontalScrollSize}px`
      } else {
        this.content.marginBottom = `0`
      }
    },
    setScrollerSize () {
      const content = this.$refs.content
      this.verticalOversize = content.clientHeight < content.scrollHeight
      this.horizontalOversize = content.clientWidth < content.scrollWidth
      this.scroller.height = content.clientHeight / content.scrollHeight * 100 + '%'
      this.horizontalScroller.width = content.clientWidth / content.scrollWidth * 100 + '%'
      this.horizontalScrollbar.width = content.offsetWidth - this.horizontalScrollSize + 'px'
    },
    setScrollPosition () {
      const content = this.$refs.content

      const scrollerHeight = content.clientHeight / content.scrollHeight
      const scrollHeight = content.scrollHeight - content.clientHeight
      this.scroller.top = (content.scrollTop - (content.scrollTop * scrollerHeight)) / (scrollHeight) * 100 + '%'

      const scrollerWidth = content.clientWidth / content.scrollWidth
      const scrollWidth = content.scrollWidth - content.clientWidth
      this.horizontalScroller.left = (content.scrollLeft - (content.scrollLeft * scrollerWidth)) / (scrollWidth) * 100 + '%'
    },
    onWrapperResize (element: HTMLElement) {
      this.onResize({el: element, old: this.wrapperSize, new: {w: element.clientWidth, h: element.clientHeight}})
    },
    onContentResize (element: HTMLElement) {
      this.onResize({el: element, old: this.contentSize, new: {w: element.clientWidth, h: element.clientHeight}})
    },
    onResize (event: {el: HTMLElement, old: {}, new: {}}) {
      this.scrolledEffect()
      this.hideScroll()
      this.setScrollerSize()
      this.setScrollPosition()
      this.calcFloatedScrollbar()
      this.handleVisibilityRecover()
      this.$emit('resize', event)
    },
    handleVisibilityRecover () {
      // The widget lives in an iframe the parent shows/hides. When it is
      // hidden via `display:none` the content height collapses to 0; on
      // re-show it grows back. After that round-trip Safari (WebKit) often
      // drops the scroll layer / overlay scrollbar of the overflow:scroll
      // element, leaving it visually un-scrollable. Detect the 0 -> visible
      // transition and rebuild the scroll layer. Skip the very first
      // measurement (initial mount) so we don't nudge needlessly.
      const content = this.$refs.content
      const h = content ? content.clientHeight : 0
      if (this.hasMeasured && this.lastClientHeight === 0 && h > 0) {
        this.nudgeScroll()
      }
      this.hasMeasured = true
      this.lastClientHeight = h
    },
    nudgeScroll () {
      // Force WebKit to recreate the scrolling layer by briefly toggling
      // `overflow`, then restore the scroll position. This is what brings
      // the overlay scrollbar / scrollability back after the iframe has been
      // hidden and shown again. No-op visually in other browsers.
      const content = this.$refs.content
      if (!content) return
      const top = content.scrollTop
      const left = content.scrollLeft
      content.style.overflow = 'hidden'
      // Read a layout property to force a synchronous reflow between the two
      // writes so the toggle actually takes effect.
      void content.offsetHeight
      content.style.overflow = '' // fall back to the stylesheet value (scroll)
      content.scrollTop = top
      content.scrollLeft = left
    },
    refresh () {
      // Public entry point used when the parent notifies the iframe that it
      // became visible again (see App.vue message handler). Covers parents
      // that hide the iframe with `visibility:hidden`, where the content
      // size does not change and ResizeObserver never fires.
      this.nudgeScroll()
      this.hideScroll()
      this.setScrollerSize()
      this.setScrollPosition()
      this.calcFloatedScrollbar()
    },
    scrolledEffect () {
      clearTimeout(this.scrolled)
      this.scrolled = setTimeout(() => {
        this.scrolled = 0
        if (this.slideScroll) {
          this.alignItemToCorner()
        }
      }, 200)
    },
    scrollPositionEmiter () {
      const content = this.$refs.content
      if (content.scrollTop <= this.topThreshold) {
        this.$emit('onScrollUp')
      }
      if (content.scrollTop >= content.scrollHeight - content.clientHeight - this.topThreshold) {
        this.$emit('onScrollDown')
      }
    },
    onScroll (event: UIEvent) {
      this.scrolledEffect()
      this.setScrollPosition()
      this.$emit('onScroll', event)
      this.scrollPositionEmiter()
    },
    update () {
      this.hideScroll()
      this.setScrollerSize()
      this.setScrollPosition()
    },
    closestSlide (): HTMLElement | null {
      const scrollLeft = this.$refs.content.scrollLeft
      let closestEl: HTMLElement | null = null
      let closestOffset = this.$refs.wrapper.clientWidth

      for (const el of this.$refs.wrapper.childNodes) {
        const element = el as HTMLElement
        const offset = Math.abs(element.offsetLeft - scrollLeft)
        if (offset < closestOffset) {
          closestOffset = offset
          closestEl = element
        }
      }
      return closestEl
    },
    alignItemToCorner () {
      const paddingLeft = parseInt(window.getComputedStyle(this.$refs.wrapper, null).getPropertyValue('padding-left'), 10)
      const closestSlide = this.closestSlide()

      this.$refs.content.scrollTo({
        left: closestSlide!.offsetLeft - paddingLeft,
        behavior: 'smooth'
      })
    },
    resetScroll () {
      this.$refs.content.scrollTop = 0
      this.$refs.content.scrollLeft = 0
      this.setScrollerSize()
      this.setScrollPosition()
      this.hideScroll()
    }
  }
})
